import { createApi } from "@reduxjs/toolkit/query/react";
import { customFetchBase } from '../../utils/API/fetchBaseQuery';
import { transformRequest } from "../../utils/API/requestMiddleware"
import { transformErrorResponse, transformSuccessResponse } from "../../utils/API/responseMiddleware";

// Define API endpoints using createApi from Redux Toolkit
const documentAPI = createApi({
    baseQuery: customFetchBase,
    reducerPath: 'documentAPI',
    endpoints: (builder) => ({

        // Endpoint to get all documents list
        getAllDocumentsList: builder.query({
            query: (data) => ({
                url: `/Documents/GetAllDocumentsList`,
                method: 'GET',
                params:data
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Mutation function to add a document
        addDocument: builder.mutation({
            query: (data) => ({
                url: 'Documents/AddDocuments',
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Mutation function to update a document
        updateDocument: builder.mutation({
            query: (data) => ({
                url: '/Documents/UpdateDocuments',
                method: 'POST',
                body: transformRequest(data),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        // Mutation function to delete a document
        deleteDocument: builder.mutation({
            query: (plDocumentKey) => ({
                url: `/Documents/DeleteDocuments?plDocumentKey=${plDocumentKey}`,
                method: 'DELETE',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        getDownloadFile: builder.query({
            query: (sDocumentFileName) => ({
                url: `/Documents/DownloadDocument?sDocumentFileName=${sDocumentFileName}`,
                method: 'GET',
                responseHandler: (response) => response.blob(),
            }),

            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
});

// Extract hooks for endpoints from documentAPI
export const {
    useLazyGetAllDocumentsListQuery,
    useAddDocumentMutation,
    useDeleteDocumentMutation,
    useUpdateDocumentMutation,
    useLazyGetDownloadFileQuery
} = documentAPI;

// Export the documentAPI
export default documentAPI;
